import angular from 'angular';

export const elastic = ($timeout) => {
    return {
        restrict: 'A',
        link: ($scope, element) => {
            const resize = () => {
                element[0].style.height = $scope.initialHeight;
                element[0].style.height = `${element[0].scrollHeight}px`;
            };

            $scope.initialHeight = $scope.initialHeight || element[0].style.height;
            element.on('input change', resize);
            $timeout(resize, 0);
        }
    };
};

angular
    .module('TALENYA-FE')
    .directive('elastic', elastic);